export const FILTER_QUERY_PARAMS = {
  BODY_TYPE: 'bodyType',
  MONTHLY_PAYMENT: 'monthlyPayment',
  MAKE: 'make',
  MODEL: 'model',
  ENGINE_TYPE: 'engineType',
  DEALS: 'deals',
  DUE_AT_SIGNING: 'dueAtSigning',
  PAGE_NUM: 'pageNum',
  SORT_BY: 'sortBy',
  ID: 'id',
  EDMUNDS_TYPE_CATEGORIES: 'edmundsTypeCategories',
  TERM: 'term',
  MILEAGE_ALLOWANCE: 'mileageAllowance',
  TOTAL_SEATING: 'totalSeating',
};

export const PAGE_SIZE = 24;

export const GEM_DEAL_THRESHOLD = 7.5;

export const DEALS_FILTER_VALUES = {
  GEMS: 'gems',
  ALL: 'all',
};

const SORT_BY_FILTER_VALUES = {
  BEST_VALUE: 'value',
  PAYMENT: 'payment',
  EFFECTIVE_PAYMENT: 'effectivePayment',
  DUE_AT_SIGNING: 'dueAtSigning',
};

export const SORT_BY_CONFIG = {
  [SORT_BY_FILTER_VALUES.BEST_VALUE]: {
    label: 'Best Value',
    sorts: [
      {
        order: 'DESC',
        by: 'EFFECTIVE_PAYMENT_RATIO',
      },
    ],
  },
  [SORT_BY_FILTER_VALUES.PAYMENT]: {
    label: 'Lowest Payment',
    sorts: [
      {
        order: 'ASC',
        by: 'PAYMENT',
      },
    ],
  },
  [SORT_BY_FILTER_VALUES.EFFECTIVE_PAYMENT]: {
    label: 'Lowest Effective Payment',
    sorts: [
      {
        order: 'ASC',
        by: 'EFFECTIVE_PAYMENT',
      },
    ],
  },
  [SORT_BY_FILTER_VALUES.DUE_AT_SIGNING]: {
    label: 'Lowest Due at Signing',
    sorts: [
      {
        order: 'ASC',
        by: 'DUE_AT_SIGNING',
      },
    ],
  },
};

export const DEFAULT_SORT_PARAM = SORT_BY_FILTER_VALUES.BEST_VALUE;

export const ZERO_DOWN_PARAM = '0down';
